import React, { useEffect, useState } from 'react';
import { List, Tag, Empty, Spin } from 'antd';
import { GiftOutlined } from '@ant-design/icons';
import CollapsibleCard from './CollapsibleCard';
import api from '../../api/axios';

/**
 * Yaklaşan doğum günleri.
 *
 * Öğretmenlerin isteğiydi: bildirim gelip geçiyor, "bir yerde görelim de
 * arkadaşımıza göre plan yapalım" dediler. Bu yüzden panel, bildirimlere
 * EK olarak duruyor — bildirimi kaçıran da buradan görebiliyor.
 *
 * YIL/YAŞ GÖSTERİLMEZ: uç zaten yıl döndürmüyor, yalnızca gün/ay ve kaç
 * gün kaldığı geliyor.
 *
 * Kapsam çağıranın şubesi (backend `authorizedBranchIds()` uyguluyor).
 */
const BirthdaysPanel = ({ days = 30 }) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/birthdays/upcoming', { params: { days } })
      .then((res) => setRows(res.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [days]);

  const etiket = (kalanGun) => {
    if (kalanGun === 0) return <Tag color="magenta">Bugün 🎂</Tag>;
    if (kalanGun === 1) return <Tag color="orange">Yarın</Tag>;
    if (kalanGun <= 7)  return <Tag color="gold">{kalanGun} gün</Tag>;
    return <span className="text-gray-400 text-xs">{kalanGun} gün</span>;
  };

  return (
    <CollapsibleCard
      title={<span><GiftOutlined /> Yaklaşan Doğum Günleri</span>}
      // Varsayilan olarak ACIK: amac zaten "goreyim de plan yapayim",
      // kapali gelirse kimse acmaz.
      defaultCollapsed={false}
    >
      {loading ? (
        <div className="flex justify-center py-4"><Spin size="small" /></div>
      ) : rows.length === 0 ? (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={`Önümüzdeki ${days} günde doğum günü yok.`}
        />
      ) : (
        <List
          size="small"
          dataSource={rows}
          renderItem={(r) => (
            <List.Item>
              <List.Item.Meta
                title={<span className="text-sm">{r.ad_soyad}</span>}
                description={<span className="text-xs text-gray-500">{r.gun_ay}</span>}
              />
              {etiket(r.kalan_gun)}
            </List.Item>
          )}
        />
      )}
    </CollapsibleCard>
  );
};

export default BirthdaysPanel;
